export default _private => {
    const { startPromise, collection } = _private;
    return function find(criteria) {
        return startPromise.then(() => {
            return collection.find(criteria);
        });
    };
};
